<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template>
  <span></span>
</template>
<script>
export default {
  name: 'VOD',
};
</script>
